
    export enum NodeType {
        Word = 1,
        And = 2,
        Or = 3,
        Not = 4,
        OpenBracket = 5,
        CloseBracket = 55,
        Phrase = 6,
        Root = 12354345345,
        FieldNameIncomplete = 88,
        Keyword = 99,
        DateOperator = 42, // Eg Before, After, From, On
        Date = 34,
        Near = 555,
        Wildcard = 777,
        WOperator = 123123,
        Within = 442,
        Of = 222212,
        FieldNameComplete = 987654321,

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/search-tree/node-type.ts